import { useState, useEffect } from "react";
import { useGlobalDispatchContext } from "../context/globalContext";
import { motion } from "framer-motion";
import { isMobile } from "react-device-detect";

//images
import img01 from "../assets/images/credits/hover1.jpg";
import img02 from "../assets/images/credits/hover2.jpg";
import img03 from "../assets/images/credits/hover3.jpg";

// variants
import { border, container, item, variant02 } from "../motion/variants";

const imgs = [
  { type: "development", src: img01 },
  { type: "author", src: img02 },
  { type: "editor", src: img03 },
];

const openUrl = (url) => {
  const win = window.open(url, "_blank");
  win.focus();
};

const splitedTxt = (text) =>
  text.split("").map((char, i) => (
    <motion.span key={i} variants={item} style={{ position: "relative" }}>
      {char}
    </motion.span>
  ));

const borderDiv = (
  <motion.div
    variants={border}
    initial="hidden"
    animate="visible"
    exit="exit"
  ></motion.div>
);

const Credits = ({}) => {
  const [mousePosition, setMousePosition] = useState({ x: 400, y: 400 });
  const [hovered, setHovered] = useState("");
  const dispatch = useGlobalDispatchContext();
  const onMouseMove = (event) => {
    const { pageX: x, pageY: y } = event;
    setMousePosition({ x, y });
  };

  useEffect(() => {
    dispatch({ type: "CURSOR_TYPE", cursorType: false });
    window.addEventListener("mousemove", onMouseMove);
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
    };
  }, []);

  return (
    <div id="credits">
      {imgs.map((elem, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0 }}
          animate={{
            top: mousePosition.y,
            left: mousePosition.x,
            opacity: hovered === elem.type ? 1 : 0,
            transition: { ease: "linear" },
          }}
          exit={{ opacity: 0 }}
          className="floating-img"
        >
          <img src={elem.src} />
        </motion.div>
      ))}

      <div className="content">
        <div className="left">
          <motion.span
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={variant02}
            transition={{ delay: 1, duration: 0.8 }}
            className="development"
          >
            DEVELOPMENT BY{" "}
            <motion.span
              onClick={() => {
                openUrl("https://www.tripalium-studio.com");
              }}
              onMouseEnter={() =>
                !isMobile ? setHovered("development") : null
              }
              onMouseLeave={() => (!isMobile ? setHovered("") : null)}
              className={"underlined"}
            >
              TRIPALIUM{borderDiv}
            </motion.span>
          </motion.span>

          <span className="author">
            <motion.p
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={container(0)}
              onClick={() => openUrl("https://studiotillackknoell.com")}
              onMouseEnter={() => (!isMobile ? setHovered("author") : null)}
              onMouseLeave={() => (!isMobile ? setHovered("") : null)}
              className={"underlined"}
            >
              {splitedTxt("Steffen Knöll")}
              {borderDiv}
            </motion.p>
          </span>
          <div className="editor">
            <motion.span
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={container(0.2)}
            >
              <i>{splitedTxt("(ed.)")}</i>{" "}
              <p
                onClick={() =>
                  openUrl(
                    "https://spectorbooks.com/nasa-apollo-11-man-on-the-moon"
                  )
                }
                className={"underlined"}
                onMouseEnter={() => (!isMobile ? setHovered("editor") : null)}
                onMouseLeave={() => (!isMobile ? setHovered("") : null)}
              >
                {splitedTxt("Spector")}
                {borderDiv}
              </p>
            </motion.span>
            <span>
              <motion.p
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={container(0.4)}
                onClick={() =>
                  openUrl(
                    "https://spectorbooks.com/nasa-apollo-11-man-on-the-moon"
                  )
                }
                onMouseEnter={() => (!isMobile ? setHovered("editor") : null)}
                onMouseLeave={() => (!isMobile ? setHovered("") : null)}
                className={"underlined"}
              >
                {splitedTxt("Books")}
                {borderDiv}
              </motion.p>
            </span>
            <span>
              <motion.p
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={container(0.6)}
                onClick={() =>
                  openUrl(
                    "https://spectorbooks.com/nasa-apollo-11-man-on-the-moon"
                  )
                }
                onMouseEnter={() => (!isMobile ? setHovered("editor") : null)}
                onMouseLeave={() => (!isMobile ? setHovered("") : null)}
                className={"underlined"}
              >
                {splitedTxt("discovered")}
                {borderDiv}
              </motion.p>
            </span>
          </div>
        </div>

        <motion.div
          variants={variant02}
          initial="hidden"
          animate="visible"
          exit={{ opacity: 0, y: 10, transition: { delay: 0, duration: 0.6 } }}
          transition={{ delay: 1.6, duration: 0.8 }}
          className="right"
        >
          <p>{rightText}</p>
        </motion.div>
      </div>
    </div>
  );
};

export default Credits;

const rightText = `NASA APOLLO 11 - Man on the Moon appears in the first year
of the Discovered series, a cooperation between the Stuttgart
State Academy of Art and Design, the HFBK University of Fine Arts
Hamburg, and the HGB Acadeny of Fine Arts Leipzig, which
honors a selection of student projects with the opportunity to
pubiish their work with Spector Books.\n\nDiscovered is a competition for editorial projects developed by
students at the Stuttgart State Academy of Art and Design,
the HFBK University of Fine Arts Hamburg, and the HGB Acodemy
of Fine Arts Leipzig, The winning entries will then be supported
through tho production and editing process by the stoff at
Spector Books, under the supervision of Professors Uii Cluss,
Ludovic Balland, and Ingo Offermanns.`;
